import { differenceInCalendarMonths, isValid } from "date-fns";

export const monthsUntil = (dueDate: Date | undefined | null): number => {
	if (!dueDate || !isValid(dueDate)) return 0;
	return Math.max(0, differenceInCalendarMonths(dueDate, new Date()));
};
